import SubmenuWithoutTabs from './SubmenuWithoutTabs';
import { SubmenuWithoutTabsProps, SubmenuWithoutTabsValueProps } from './types';

export type { SubmenuWithoutTabsProps, SubmenuWithoutTabsValueProps };
export default SubmenuWithoutTabs;
